import React, { useState, useEffect, useRef } from 'react';
import './PlateSetting.css';

import { PageTitle } from '../../../components';

import { FaMotorcycle, FaCarAlt, FaCarSide, FaPlusCircle, FaCreditCard, FaRegCreditCard, FaCalendarCheck, FaLock } from 'react-icons/fa';
import { SiLine } from 'react-icons/si'; // 從 react-icons 庫導入 LINE 圖標
import { PlateDynamicInputList } from '../../../components/';
import { MessageModal } from '../../../components';
import { useTokenCheck, getPlateSetting, callUpdatePlates, callAddPlates } from '../../../constants';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import CookieConsentModal from '../../../components/CookieConsentModal/CookieConsentModal';

const PlateSetting = () => {
  const { nickName, isCanExecute } = useTokenCheck();

  const navigate = useNavigate();

  // #region 需要密碼，返回要前往會員中心

  const location = useLocation();

  // Louis Add new function: 取得QueryParams
  // 當Query String中的變數action=update, 表示為更新資料

  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  };

  const queryParams = getQueryParams();
  const [action, setAction] = useState("new");//預設註冊

  useEffect(() => {
    if (queryParams["action"] !== undefined && queryParams["action"] !== "") {
      setAction(queryParams["action"]);
    }
  }, [queryParams]);

  // Louis: 完成傳入參數的檢查


  const [isApiHavePassword, setApiHavePassword] = useState(false);//預設註冊

  const [validatePassword, setValidatePassword] = useState('');

  const validatePasswordRef = useRef(null);

  const handleValidatePasswordChange = (e) => {
    const value = e.target.value;
    setValidatePassword(value);
  };

  const validateLength = (value) => {
    return value.trim().length === 0;
  };


  const setNextPage = () => {
    if (action === "update") {
      navigate("/MemberProfile");
    } else if (action === "new") {
      navigate("/Payment");
    }
  };

  // #endregion

  const [carPlates, setCarPlates] = useState([]); // 存儲汽車車牌的狀態
  const [motorPlates, setMotorPlates] = useState([]); // 存儲機車車牌的狀態

  useEffect(() => {
    if (!isCanExecute) return;
    const chacngeRegistreProcessing = () => {
      if (Cookies.get('cookieConsent') === 'accepted') {

        if (Cookies.get('isRegistreProcessing') === 'true') {
          setApiHavePassword(false);//不需要密碼
        } else {
          setApiHavePassword(true);
          if (action === "new") {
            setAction('update');
          }
        }
      } else {

        // 沒有同意 Cookie 的情況
      }
    }
    getPlateSetting().then(payload => {
      const isPayloadValid =
        payload?.status !== undefined &&
        payload?.errorCode !== undefined &&
        payload?.data !== undefined &&
        payload?.errorMessage !== undefined;

      if (isPayloadValid) {
        if (payload.status === 0 && payload.errorCode === '0000') {
          if (payload.data == null) {
            setCarPlates(['']);
            setMotorPlates(['']);
          } else if (payload.data != null) {


            let temp1 = payload?.data['1'] ? payload.data['1']?.plates : [''];
            setCarPlates(temp1);

            let temp2 = payload?.data['2'] ? payload.data['2']?.plates : [''];
            setMotorPlates(temp2);

          }
        } else if (payload.status === 1 &&
          (payload.errorCode === '9997' || payload.errorCode === '9998')) {
          //未登入
          let errorMessage = "Token過期，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else if (payload.status === 1 && payload.errorCode === '9996') {
          //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
          let errorMessage = "查無此會員，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else {
          let errorMessage = payload.errorMessage;
          MessageModal.alert(errorMessage);
        }
      }
      chacngeRegistreProcessing();
    }).catch(error => {
      console.error('Error during API call:', error);
    });

  }, [isCanExecute]);

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    const filteredCarPlates = carPlates.filter(plate => plate.trim() !== '');
    const filteredMotorPlates = motorPlates.filter(plate => plate.trim() !== '');

    // 檢查陣列中是否有重複的車牌號碼
    function hasDuplicateInArray(arr) {
      const plateSet = new Set();
      for (const plate of arr) {
        if (plateSet.has(plate)) {
          return true;
        }
        plateSet.add(plate);
      }
      return false;
    }

    // 檢查車牌號碼是否有重複（包括自己陣列內部和跨陣列檢查）
    function hasDuplicatePlates(carPlates, motorPlates) {
      if (hasDuplicateInArray(carPlates) || hasDuplicateInArray(motorPlates)) {
        return true; // 發現重複的車牌號碼
      }

      const allPlates = new Set(carPlates);
      for (const plate of motorPlates) {
        if (allPlates.has(plate)) {
          return true; // 發現重複的車牌號碼
        }
      }

      return false; // 沒有重複的車牌號碼
    }

    let isValidate = hasDuplicatePlates(filteredCarPlates, filteredMotorPlates);
    if (isValidate) {
      MessageModal.alert('車牌號碼不能重複');
      return;
    }

    if (isApiHavePassword && validateLength(validatePassword)) {
      const handleError = () => {
        setValidatePassword('');
        if (validatePasswordRef.current) {
          validatePasswordRef.current.focus();
        }
      };
      MessageModal.alert('請輸入密碼進行驗證', handleError);
      return;
    }

    if (isApiHavePassword) {
      const formData = {
        "1": {
          "type": "汽車",
          "plates": filteredCarPlates
        },
        "2": {
          "type": "機車",
          "plates": filteredMotorPlates
        }
      };

      callUpdatePlates(formData, validatePassword).then(payload => {

        const isPayloadValid =
          payload?.status !== undefined &&
          payload?.errorCode !== undefined &&
          payload?.data !== undefined &&
          payload?.errorMessage !== undefined;

        if (isPayloadValid) {

          if (payload.status === 0 && payload.errorCode === '0000') {
            // 處理結果

            setNextPage();

          } else if (payload.status === 1 && payload.errorCode === '9995') {

            const handleError = () => {
              setValidatePassword('');
              if (validatePasswordRef.current) {
                validatePasswordRef.current.focus();
              }
            };

            MessageModal.alert('請確認密碼是否正確', handleError);
          } else if (payload.status === 1 &&
            (payload.errorCode === '9997' || payload.errorCode === '9998')) {
            //未登入
            let errorMessage = "Token過期，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else if (payload.status === 1 && payload.errorCode === '9996') {
            //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
            let errorMessage = "查無此會員，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else {
            let errorMessage = payload.errorMessage;
            MessageModal.alert(errorMessage);
          }
        }
      }).catch(error => {
        console.error('Error during API call:', error);
      });
    } else {
      const formData = {
        "1": {
          "type": "汽車",
          "plates": filteredCarPlates
        },
        "2": {
          "type": "機車",
          "plates": filteredMotorPlates
        }
      };

      callAddPlates(formData).then(payload => {

        const isPayloadValid =
          payload?.status !== undefined &&
          payload?.errorCode !== undefined &&
          payload?.errorMessage !== undefined;

        if (isPayloadValid) {

          if (payload.status === 0 && payload.errorCode === '0000') {
            // 處理結果            
            setNextPage();

          } else if (payload.status === 1 &&
            (payload.errorCode === '9997' || payload.errorCode === '9998')) {
            //未登入
            let errorMessage = "Token過期，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else if (payload.status === 1 && payload.errorCode === '9996') {
            //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
            let errorMessage = "查無此會員，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else {
            let errorMessage = payload.errorMessage;
            MessageModal.alert(errorMessage);
          }
        }
      }).catch(error => {
        console.error('Error during API call:', error);
      });
    }
  };

  return (
    <>
      {/* 確認是否使用cookies */}
      <CookieConsentModal />

      {/* Page Title */}
      <PageTitle title={'設定車籍資料'} page={'plate'} />

      <section className='PlateSetting'>

        {/* Registration Form */}
        <form className='account-form' onSubmit={handleSubmit}>

          {/* User Icon */}
          <div className='icon'><FaCarAlt /></div>

          {/* Heading for the register form */}
          <h3>設定車籍資料</h3>
          {/* Terms and Conditions Checkbox */}
          <div className='terms'>
            <h4>汽車:</h4>
            <label>請填寫您所屬的汽車車牌</label>
          </div>
          <PlateDynamicInputList
            icon={FaCarSide}
            placeholder="汽車車號"
            maxItems={3}
            onItemsChange={setCarPlates}
            initialItems={carPlates}
          />
          {/* Terms and Conditions Checkbox */}
          <div className='terms'>
            <h4>機車:</h4>
            <label>請填寫您所屬的機車車牌</label>
          </div>
          <PlateDynamicInputList
            icon={FaMotorcycle}
            placeholder="機車車號"
            maxItems={3}
            onItemsChange={setMotorPlates}
            initialItems={motorPlates}
          />

          {action === "update" &&
            <div className="validatePassword">
              <div className='terms'>
                <h4>密碼:</h4>
                <label>修改資料需輸入舊密碼進行驗證</label>
              </div>
              <div className="input-field">
                <label htmlFor="validate-password"><FaLock /></label>
                <input type="password" name="validate-password" placeholder="如果需要修改資料，需填入密碼。" id="validate-password" className="box"
                  maxLength="16" value={validatePassword} onChange={handleValidatePasswordChange} ref={validatePasswordRef} />
              </div>
              <div className='notice'>
                <label >為了保障您的資料安全性，更新需要驗證密碼。
                </label>
              </div>
            </div>
          }


          <button name='submit' id='submit' className='btn'>填寫完成</button>
          {action === "new" && <Link to="/Payment" ><button name='ignore' id='ignore' className='btn'>暫時不設定</button></Link>}
          {action === "update" && <Link to="/MemberProfile"><button name='ignore' id='ignore' className='btn'>回到會員中心</button></Link>}

        </form>

      </section>
    </>
  );
}

export default PlateSetting;